
import React from 'react';

import Chooseplasticbottl from './Chooseplasticbottl';
import Injectmoldflexible from './Injectmoldflexible';

const Chooseplasticb = () => {
    return (
        <div>
            <Chooseplasticbottl />
            <Injectmoldflexible />
        </div>
    );
};

export default Chooseplasticb;
